import type { FC } from 'react';
import StudioHeaderMobile from '../../../StudioHeaderMobile';
import StudioBlankSlate from '../../../StudioBlankSlate';
import LayoutContainer from '../../_partials/LayoutContainer';

const BlankSlateLayout: FC<{}> = () => (
  <LayoutContainer>
    <StudioHeaderMobile />
    <StudioBlankSlate />
  </LayoutContainer>
);
BlankSlateLayout.displayName = 'BlankSlateLayout';

export default BlankSlateLayout;
